import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpParamNames } from 'src/app/core/constantes/http_param-names';
import { Results } from 'src/app/models/server/core/results-T';
import { ListLayout } from 'src/app/models/server/list-layout';
import { ConnectedUsersStateService } from '../state/connected-users-state.service';
import { ViewsStateService } from '../state/views-state.service';
import { ServiceBase } from './service-base';

@Injectable({
    providedIn: 'root',
})
export class ListLayoutsService extends ServiceBase {
    constructor(
        private http: HttpClient,
        public override connectedUserStateService: ConnectedUsersStateService,
        private viewsStateService: ViewsStateService
    ) {
        super(connectedUserStateService);
    }

    /**
     * Liste les listLayout
     * @param viewId : Identifiant de la vue.
     */
    List(viewId: number): Observable<ListLayout[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                sort: this.getHeader(null),
                filters: this.getHeader([]),
                context: this.getHeader(null),
            }),
            params: new HttpParams().set(HttpParamNames.FROM, '0').set(HttpParamNames.SIZE, '1000'),
        };

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/listLayouts`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<ListLayout>(ListLayout, x);

                return res.value;
            })
        );
    }

    /**
     * Récupère la mise en page correspondant à un id.
     * @param layoutId Id de la mise en page.
     * @returns la mise en page.
     */
    public get(layoutId: number): Observable<ListLayout> {
        const httpOptions = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
        };
        return this.http.get<ListLayout>(
            this.baseUrl + `/api/organizations/${this.userConnected.organization.id}/views/${this.viewsStateService.getSelectedView().id}/listLayouts/${layoutId}`,
            httpOptions
        );
    }
}
